const STORE_ID = "LOG_W3ERP";

const TYPES = {
    SET_GET_ALL: 'SET_GET_ALL',
    LOG: 'LOG',
    SET_TAB: "SET_TAB",
}

export {STORE_ID, TYPES}
